import * as React from 'react';

import { useQuery, useApolloClient } from '@apollo/client';

import {
  GetProductsByIdBatchedQuery,
  GetProductsByIdBatchedQueryVariables,
} from '@notino/shared/definitions/types';

import getProductsByIdBatchedQuery from '@components/Universals/BatchVPProductQuery/queries/productsByIdBatched.graphql';

interface UseSsrWishlistProductsParams {
  productIds: string[];
  pageSize: number;
}

const useProductsSsrQuery = (
  productIds: UseSsrWishlistProductsParams['productIds']
) => {
  useQuery<GetProductsByIdBatchedQuery>(getProductsByIdBatchedQuery, {
    ssr: true,
    skip: typeof window !== 'undefined',
    variables: {
      ids: productIds,
    },
  });
};

export const useSsrWishlistProducts = ({
  productIds,
  pageSize,
}: UseSsrWishlistProductsParams) => {
  const { cache } = useApolloClient();
  useProductsSsrQuery(productIds.slice(0, pageSize));

  return React.useState<GetProductsByIdBatchedQuery['vpProductByIds']>(() => {
    const ssrProducts = cache.readQuery<
      GetProductsByIdBatchedQuery,
      GetProductsByIdBatchedQueryVariables
    >({
      query: getProductsByIdBatchedQuery,
      variables: {
        ids: productIds.slice(0, pageSize),
      },
    })?.vpProductByIds;

    return (ssrProducts || []).filter(Boolean);
  });
};
